import { render, staticRenderFns } from "./UnsupportedDevice.vue?vue&type=template&id=37f78ba4&lang=pug&"
import script from "./UnsupportedDevice.vue?vue&type=script&lang=js&"
export * from "./UnsupportedDevice.vue?vue&type=script&lang=js&"
import style0 from "./UnsupportedDevice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports